import { isDeliveryMode, countryCode, capitalizeFirstLetter, isEmpty } from 'utils/appUtils'
import { getCurrentPage } from './index'
import { store } from '../config/redux'

const track = payload => {
    const state = store.getState()
    const { user, subscription } = state
    const userProfile = user && user.get('userProfile') && user.get('userProfile').toJS()
    const subscriptionFromProfile = (userProfile && userProfile?.subscriptions?.[0]) || {}
    const subscriptionDetails = subscription && subscription.subscriptionPlanDetails
    const isUserSubscribed =
        subscriptionFromProfile?.hasOwnProperty('status') ||
        subscriptionDetails?.hasOwnProperty('status')
    const subscriptionStatus = isUserSubscribed
        ? capitalizeFirstLetter(subscriptionFromProfile?.status || subscriptionDetails?.status)
        : 'Unsubscribed'
    window.mixpanel.track(payload.name, {
        ...payload,
        'delivery subscription': subscriptionStatus,
    })
}

const mixPanelSuper = (payload, removePayload) => {
    if (removePayload) {
        window.mixpanel.unregister(removePayload)
    }
    window.mixpanel.register(payload)
}

const identify = payload => {
    window.mixpanel.identify(payload)
}

export const insertIf = (condition, obj) => (condition ? obj : {})

export const trackLoginMethod = (method, success, payload, state) => {
    let loyaltyId
    if (success) {
        const { user } = state
        const userProfile = user && user.get('userProfile') && user.get('userProfile').toJS()
        loyaltyId = userProfile && userProfile.loyalty_id
    }

    track({
        name: 'sign in result',
        'sign in method': method,
        'sign in success': success,
        ...insertIf(!success, { 'failure reason': payload }),
    })
}

export const trackDisplayType = currentScreen => {
    mixPanelSuper({
        'display type': currentScreen,
    })
}

export const addLoyaltyIdForWebsite = profile => {
    const loyaltyId = profile?.loyalty_id
    mixPanelSuper({
        'member id': loyaltyId,
    })
    identify(loyaltyId)
}
export const trackUserRegistrationStart = location => {
    track({
        name: 'registration started',
        'source page': location,
    })
}
export const trackUserRegistrationSuccess = location => {
    track({
        name: 'registration success',
        'source page': location,
    })
}

export const trackUserRegistrationComplete = (success, payload, state) => {
    track({
        name: 'registration result',
        'registration success': success,
        ...insertIf(!success, { 'failure reason': payload }),
    })
}

export const trackLandingPageViewed = () => {
    track({
        name: 'landing page viewed',
        'source page': 'landing',
    })
}
export const trackHomePageViewed = () => {
    track({
        name: 'home page viewed',
        'source page': 'home',
    })
}
export const trackDealsPageViewed = () => {
    track({
        name: 'deals page viewed',
        'source page': 'deals',
    })
}

export const trackShopPageViewed = () => {
    track({
        name: 'shop page viewed',
        'source page': 'shop',
    })
}

export const trackCategoryPageViewed = category => {
    track({
        name: 'category page viewed',
        'source page': category,
        'category name': category,
    })
}

export const trackCateringPageViewed = catering => {
    track({
        name: 'catering page viewed',
        'source page': catering,
    })
}

export const trackSubCategoryPageViewed = (location, state) => {
    track({
        name: 'sub category page viewed',
        'source page': location,
        'sub category name': state.selectedSubCategory,
    })
}

export const trackProductDetailsPageViewed = (location, state) => {
    const product = state
    track({
        name: 'product details page viewed',
        'source page': location,
        'product name': product.name,
        'product category name': product.category,
        'product sub category name': product.tags ? product.tags[0] : '',
        'is Promo': product.promos.length >= 1,
        'original price': product.price / 100,
        'promo price': product.promo_price,
        'product sku': product.availableQuantity,
    })
}

export const trackOrdersPageViewed = () => {
    track({
        name: 'orders page viewed',
    })
}
export const trackOrderStatusPageViewed = (location, response) => {
    const today = new Date()
    const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`
    track({
        name: 'order status page viewed',
        'source page': location,
        'order status': response.order_status,
        'current local time ': time,
        'order id': response.order_id,
        'order cost': response.total / 100,
    })
}

export const trackHelpPageViewed = location => {
    track({
        name: 'help page viewed',
        'source page': `${location} - account`,
    })
}
export const trackSetLocation = (location, state) => {
    const isFirstTime = isEmpty(state.location.getIn(['selectedAddress']))
    track({
        name: isFirstTime ? 'initial location page viewed' : 'confirm location page viewed',
        'selected city': location ? location.city : '',
        'selected state': location ? location.state : '',
        'order type': location ? location.type : '',
        'source page': window.location.pathname,
    })
}

export const trackLocationConfirmedResult = (isSuccess, location, state, failureReason = '') => {
    track({
        name: 'location confirmed result',
        'location confirmed success': isSuccess,
        'failure reason': failureReason,
        'selected city': location.city,
        'user delivery country': location.country,
        'selected state': location.state,
        'order type': location.type,
    })
    if (isSuccess) {
        mixPanelSuper({
            'delivery country':
                location.country === countryCode.US
                    ? 'USA'
                    : location.country === countryCode.CA
                      ? 'Canada'
                      : 'N/A',
        })
    }
}

export const trackProductSearch = (type, searchString, count, location, state) => {
    track({
        name: 'search executed',
        'search type': type,
        'search string': searchString,
        'results returned': count,
        'current page': location,
    })
}
export const trackCartAddRemoveItem = (
    operation,
    item,
    basketResponse,
    basketState,
    mixpanelFlagForAi = false,
    mixpanelFlagForSearch = false
) => {
    const suggestiveAImodal = basketState?.suggestiveItemsRawData?.source_list === 'AI'
    const suggestiveItemIndex = basketState?.suggestiveItemsRawData?.items.findIndex(
        each => each.product_id === item.product_id
    )
    track({
        name: operation === 'add' ? 'item added to basket' : 'item removed from basket',
        'current page': mixpanelFlagForSearch ? 'search quick add' : window.location.pathname,
        'ai model used': mixpanelFlagForAi && suggestiveAImodal ? 'Just For You' : 'N/A',
        'position index': mixpanelFlagForAi && suggestiveAImodal ? suggestiveItemIndex + 1 : 'N/A',
        'product category': item.category,
        'product subcategory': item.subCategory,
        'product name': item.name,
        'is promo': item?.promos?.length > 0,
        'original price': `$${(item.price / 100).toFixed(2)}`,
        'promo price': `$${(item.promo_price / 100).toFixed(2)}`,
        'product sku': item.product_id,
        'current basket size': basketResponse?.items.reduce((sum, i) => sum + i.quantity, 0),
        'current basket value': `$${(basketResponse.subtotal / 100).toFixed(2)}`,
    })
}

export const trackBasketPageViewed = (location, basket, suggestiveItems) => {
    const trueETA = basket && basket.basketResponse && basket.basketResponse.ETA
    const etaArr = trueETA
        ? basket && basket.basketResponse && basket.basketResponse.ETA.split('')
        : []
    const minEta = etaArr.slice(0, 2).join('')
    const maxEta = etaArr.slice(5, 7).join('')
    const today = new Date()
    const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`
    const basketResponse = basket && basket.basketResponse
    const basketTotal = basketResponse ? Math.floor(basketResponse.subtotal) : 0
    const basketItemsTrue = basket && basket.basketItems
    const basketItems = basketItemsTrue ? basket.basketItems.map(each => each.name).toString() : []
    const ageRestrictedProducts = basketItemsTrue.some(
        item => item && item.age_restricted === true && item.count != 0
    )
    const suggestiveAImodal = suggestiveItems?.source_list === 'AI'
    const suggestiveSlins = suggestiveItems?.items.map(each => each.slin)

    track({
        name: 'basket page viewed',
        'source page': location,
        'min eta': `${minEta} minutes`,
        'max eta': `${maxEta} minutes`,
        'current local time': time,
        'basket size': basketItems && basketItems.length,
        'basket value': basketTotal,
        'basket items': basketItems,
        'is promo': basketResponse?.promoCodeResponse,
        'is reorder': basket?.reorderDone,
        'is age restricted': ageRestrictedProducts,
        'ai model shown': suggestiveAImodal ? 'True' : 'False',
        'Just For You items': suggestiveSlins,
    })
}

export const trackCheckoutPageViewed = (location, basket, wallet) => {
    const delivery = isDeliveryMode()
    const trueETA = basket && basket.basketResponse && basket.basketResponse.ETA
    const etaArr = trueETA
        ? basket && basket.basketResponse && basket.basketResponse.ETA.split('')
        : []
    const minEta = etaArr.slice(0, 2).join('')
    const maxEta = etaArr.slice(5, 7).join('')
    const today = new Date()
    const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`
    const basketResponse = basket && basket.basketResponse
    const basketTotal = basketResponse ? Math.floor(basketResponse.subtotal) : 0
    const basketItemsTrue = basket && basket.basketItems
    const basketItems = basketItemsTrue ? basket.basketItems.map(each => each.name).toString() : []

    const ageRestrictedProducts = basketItemsTrue.some(
        item => item && item.age_restricted === true && item.count != 0
    )
    const paymentMethod =
        (wallet.selectedCard && wallet.selectedCard.brand) ||
        (wallet.defaultCard && wallet.defaultCard.brand)

    let deliveryFee
    let additionalFee
    let totalCost
    if (delivery && basket?.basketResponse?.basketSummary) {
        deliveryFee = basket.basketResponse.basketSummary.find(
            item => item.name === 'Delivery Fee' || 'Delivery Fee (Promo Applied)'
        )
        deliveryFee = deliveryFee ? deliveryFee.value : 0
        const extraFees = basket.basketResponse.basketSummary.find(
            item => item.name === 'Total Fees'
        )
        additionalFee = extraFees?.toolTipData?.map(item => item.name)
        additionalFee && additionalFee.pop()
        additionalFee = additionalFee?.toString()
        totalCost = basket.basketResponse.basketSummary.find(item => item.name === 'Total Fees')
        totalCost = totalCost ? totalCost.value : 0
    } else {
        deliveryFee = 0 // pickup mode won't have delivery mode
        additionalFee = ''
        totalCost = 0
    }

    track({
        name: 'checkout page viewed',
        'source page': location,
        'min eta': `${minEta} minutes`,
        'max eta': `${maxEta} minutes`,
        'payment method': paymentMethod,
        'current local time': time,
        'basket size': basket?.basketItems?.length,
        'basket items': basketItems,
        'is promo': basket?.basketResponse?.promoCodeResponse,
        'is reorder': basket?.reorderDone,
        'is age restricted': ageRestrictedProducts,
        'sub total': basketTotal,
        'delivery fee': deliveryFee && deliveryFee,
        'additional fee': additionalFee && additionalFee,
        'total fees': totalCost && totalCost,
    })
}

export const trackPlaceOrderPageViewed = (location, basket, wallet) => {
    const delivery = isDeliveryMode()
    const trueETA = basket && basket.basketResponse && basket.basketResponse.ETA
    const etaArr = trueETA
        ? basket && basket.basketResponse && basket.basketResponse.ETA.split('')
        : []
    const minEta = etaArr.slice(0, 2).join('')
    const maxEta = etaArr.slice(5, 7).join('')
    const today = new Date()
    const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`
    const basketResponse = basket && basket.basketResponse
    const basketTotal = basketResponse ? Math.floor(basketResponse.subtotal) : 0
    const basketItemsTrue = basket && basket.basketItems
    const basketItems = basketItemsTrue ? basket.basketItems.map(each => each.name).toString() : []

    const ageRestrictedProducts = basketItemsTrue?.some(
        item => item && item.age_restricted === true && item.count != 0
    )
    const paymentMethod =
        (wallet.selectedCard && wallet.selectedCard.brand) ||
        (wallet.defaultCard && wallet.defaultCard.brand)

    let deliveryFee
    let additionalFee
    let totalCost
    let totalTax
    if (delivery && basket?.basketResponse?.basketSummary) {
        deliveryFee = basket.basketResponse.basketSummary.find(
            item => item.name === 'Delivery Fee' || 'Delivery Fee (Promo Applied)'
        )
        deliveryFee = deliveryFee ? deliveryFee.value : 0
        const extraFees = basket.basketResponse.basketSummary.find(
            item => item.name === 'Total Fees'
        )
        additionalFee = extraFees?.toolTipData?.map(item => item.name)
        additionalFee && additionalFee.pop()
        additionalFee = additionalFee?.toString()
        totalCost = basket.basketResponse.basketSummary.find(item => item.name === 'Total Fees')
        totalCost = totalCost ? totalCost.value : 0
    } else {
        deliveryFee = 0 // pickup mode won't have delivery mode
        additionalFee = ''
        totalCost = 0
    }

    if (basket.checkoutResponse) {
        totalTax = basket?.checkoutResponse?.summary?.find(item => item.name === 'Tax & Fees')
        totalTax = totalTax ? totalTax?.value : 0
    }

    track({
        name: 'place order page viewed',
        'source page': location,
        'min eta': `${minEta} minutes`,
        'max eta': `${maxEta} minutes`,
        'payment method': paymentMethod,
        'current local time': time,
        'basket size': basket && basket.basketItems && basket.basketItems.length,
        'basket items': basketItems,
        'is promo': basket && basket.basketResponse && basket.basketResponse.promoCodeResponse,
        'is reorder': basket && basket.reorderDone,
        'is age restricted': ageRestrictedProducts,
        'sub total': basketTotal,
        'delivery fee': deliveryFee && deliveryFee,
        'additional fee': additionalFee && additionalFee,
        'total fees': totalCost && totalCost,
        'total tax': totalTax && totalTax,
        // 'promo code used': ,
        // 'promo code value': ,
    })
}

export const trackDynamicCategoryPageViewed = (location, products) => {
    track({
        name: 'dynamic category page viewed',
        'source page': location,
        'current category': products?.selectedSubCategory,
    })
}

export const trackCheckoutCompleted = (location, response) => {
    const trueETA = response && response.eta_range
    const etaArr = trueETA ? response && response.eta_range.split('') : []
    const minEta = etaArr.slice(0, 2).join('')
    const maxEta = etaArr.slice(5, 7).join('')
    const today = new Date()
    const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`

    const Total = Math.floor(response?.total)
    let basketItems = ''
    basketItems = response?.original_items?.map(each => each.name)
    basketItems = basketItems.toString()
    const ageRestrictedProducts = response?.original_items?.some(
        item => item && item.age_restricted === true && item.count != 0
    )
    const paymentMethod = response?.payment?.brand
    const deliveryFee = response?.delivery_fee
    let totalTax = response?.summary?.find(each => each.name === 'fee')
    totalTax = totalTax ? totalTax.display_value : 0

    track({
        name: 'checkout completed',
        'source page': location,
        'min eta': `${minEta} minutes`,
        'max eta': `${maxEta} minutes`,
        'payment method': paymentMethod,
        'current local time': time,
        'basket size': response?.original_items?.length,
        'basket items': basketItems,
        'is promo': response?.promo_items?.length > 0,
        'is age restricted': ageRestrictedProducts,
        'sub total': `$${(response?.subtotal / 100).toFixed(2)}`,
        'delivery fee': deliveryFee && `$${(typeof deliveryFee === 'number' ? deliveryFee.toFixed(2) : deliveryFee)}`,
        'total cost': `$${(Total / 100).toFixed(2)}`,
        'total tax': totalTax && `${(typeof totalTax === 'number' ? totalTax.toFixed(2) : totalTax)}`,
        'order type': isDeliveryMode() ? 'delivery' : 'pickup',
    })
}

export const trackCheckoutCancelled = () => {
    track({
        name: 'checkout cancelled',
    })
}

export const trackFeedbackSubmitted = (location, response) => {
    track({
        name: 'feedback submitted',
    })
}
export const trackPromoCodeEntered = (location, response) => {
    track({
        name: 'promo code entered',
        'source page': location,
        'promo code used': response?.coupon_name,
        'promo successful': response?.coupon_applied,
    })
}

export const trackFeesExpanded = (location, fees) => {
    let deliveryFee
    let additionalFee
    let totalCost
    if (fees) {
        deliveryFee = fees.find(
            item => item.name === 'Delivery Fee' || 'Delivery Fee (Promo Applied)'
        )
        deliveryFee = deliveryFee ? deliveryFee.value : 0
        const extraFees = fees.find(item => item.name === 'Total Fees')
        additionalFee = extraFees?.toolTipData?.map(item => item.name)
        additionalFee && additionalFee.pop()
        additionalFee = additionalFee?.toString()
        totalCost = fees.find(item => item.name === 'Total Fees')
        totalCost = totalCost ? totalCost.value : 0
    }

    track({
        name: 'fees expanded',
        'source page': location,
        'delivery fee': deliveryFee && deliveryFee,
        'additional fee': additionalFee && additionalFee,
        'total fees': totalCost && totalCost,
    })
}
export const trackAppDownloadClicked = location => {
    track({
        name: 'app download clicked',
        'source page': location,
    })
}

export const trackWebviewOpened = () => {
    mixPanelSuper({
        'display type': 'web view',
    })
}

export const trackWebviewSessionstarted = () => {
    track({
        name: 'web view session started',
    })
}

export const trackErrorScreen = errorDescription => {
    const location = getCurrentPage()
    track({
        name: 'error screen',
        'error description': errorDescription && errorDescription,
        'source page': location && location,
    })
}

export const trackActionItemChanged = (productName, currentSelected, previousSelected) => {
    track({
        name: 'if unavailable changed',
        'product name': productName,
        'if unavailable choice': currentSelected,
        'if unavailable default': previousSelected,
    })
}

export const trackFeedbackReceived = (rating, comment, root, reward) => {
    track({
        name: 'feedback received',
        'feedback source': root,
        'feedback reward': reward,
        'comment received': comment ? 'Yes' : 'No',
        comment: comment || '',
        rating,
    })
}

export const trackOrderUpdateReceived = UpdateType => {
    track({
        name: 'Order update received',
        'update type': UpdateType,
    })
}

export const trackAlertBannerShown = description => {
    track({
        name: 'alert banner shown',
        'alert description': description,
    })
}
export const trackAgeVerification = () => {
    track({
        name: 'age verification prompted',
    })
}

export const trackAgeVerificationResponse = response => {
    track({
        name: 'age verification response',
        response,
    })
}

export const trackAgeVerificationResult = result => {
    track({
        name: 'age verification result',
        result,
    })
}

export const trackHelpCenterAccessPoint = () => {
    let location = window.location.pathname.slice(1)
    location += 'page'
    track({
        name: 'help center accessed ',
        'current page': location,
    })
}

export const trackHelpCenterTicketCreated = response => {
    track({
        name: 'help center ticket created',
        'order id': response?.order_id || null,
        'order status': response?.order_status || null,
    })
}

export const trackHelpCenterArticleAccessed = (articleDetails, orderDetails) => {
    let location = window.location.pathname.slice(1)
    location += 'page'
    track({
        name: 'help center article displayed',
        'article name': articleDetails.title,
        'current page': location,
        'order id': orderDetails?.order_id || null,
        'order status': orderDetails?.order_status || null,
        'order state': !isEmpty(orderDetails)
            ? orderDetails.order_status === 'submitted'
                ? 'Active Order'
                : 'Past Order'
            : null,
    })
}

export const trackVotesForHelpCenterArticles = (voteType, articleDetails, orderDetails) => {
    track({
        name: 'help center article rated',
        feedback: voteType === 'UP' ? 'Helpful' : 'Not Helpful',
        'article name': articleDetails.title,
        'order id': orderDetails?.order_id || null,
        'order status': orderDetails?.order_status || null,
        'order state': !isEmpty(orderDetails)
            ? orderDetails.order_status === 'submitted'
                ? 'Active Order'
                : 'Past Order'
            : null,
    })
}

export const trackHelpCenterCallOrSms = (orderDetails, channelType) => {
    let location = window.location.pathname.slice(1)
    location += 'page'
    track({
        name: 'contact us',
        'order id': orderDetails?.order_id || null,
        'order status': orderDetails?.order_status || null,
        'order state':
            orderDetails && orderDetails.order_status === 'submitted'
                ? 'Active Order'
                : 'Past Order',
        'current page': location,
        'channel type': channelType || null,
    })
}

export const trackRafPageAccessedFrom = source => {
    let location = source
    location += 'page'
    track({
        name: 'referral info sheet accessed',
        source: location,
    })
}

export const trackRafCredits = source => {
    track({
        name: 'referral info sheet accessed',
        'has referral credit': source,
    })
}

export const trackRafSharingMethod = method => {
    track({
        name: 'referral code copied',
        'share method': method,
    })
}

export const trackRafCodeRedemption = source => {
    track({
        name: 'referral code redeemed',
        'redemption location': source,
    })
}

export const addSubscriptionSuperProp = subscription => {
    const isUserSubscribed = subscription?.hasOwnProperty('status')
    const subscriptionStatus = isUserSubscribed
        ? capitalizeFirstLetter(subscription?.status)
        : 'Unsubscribed'
    mixPanelSuper({
        'delivery subscription': subscriptionStatus,
    })
}

export const trackSubscriptionInfoAccessed = source => {
    track({
        name: 'subscription info sheet accessed',
        source,
    })
}

export const trackUserGetStartedSubscription = source => {
    track({
        name: 'subscription info sheet action',
        CTA: source,
    })
}

export const trackStartSubscription = (source, isTrial, isReactivate) => {
    track({
        name: 'subscription start',
        source,
        trial: isTrial,
        reactivate: isReactivate,
    })
}

export const trackCancelSubscription = (source, reason) => {
    track({
        name: 'subscription cancel',
        source,
        'cancel reason': reason,
    })
}

export const trackSubscriptionPaymentError = () => {
    track({
        name: 'subscription funding error',
    })
}

export const trackUserFreeItemClick = () => {
    track({
        name: 'free item click',
    })
}

export const trackFreeItemContinue = (itemSlin, itemName) => {
    track({
        name: 'free item continue',
        'free item slin': itemSlin,
        'free item name': itemName,
    })
}

// ============================================
// CATERING TRACKING EVENTS
// ============================================

// Helper to get common catering properties
const getCateringCommonProps = () => {
    const state = store.getState()
    const { user } = state
    const userProfile = user && user.get('userProfile') && user.get('userProfile').toJS()
    const loyaltyId = userProfile && userProfile.loyalty_id
    
    return {
        loyalty_id: loyaltyId || null,
        timestamp: new Date().toISOString(),
        platform: 'web',
        device_type: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
    }
}

// 1. Page views
export const trackCateringPageViewsViewed = (source = 'web') => {
    track({
        name: 'catering_page_views_viewed',
        source,
        ...getCateringCommonProps(),
    })
}

// 2. User Behavior - clear cart flow
export const trackCateringUserBehaviorClearCartFlowModalOpened = (shopItemsCount, sourcePage) => {
    track({
        name: 'catering_user_behavior_clear_cart_flow_modal_opened',
        shop_items_count: shopItemsCount,
        source_page: sourcePage,
        ...getCateringCommonProps(),
    })
}

export const trackCateringUserBehaviorClearCartFlowContinueOrder = (shopItemsCount, actionResult = 'continued') => {
    track({
        name: 'catering_user_behavior_clear_cart_flow_continue_order',
        shop_items_count: shopItemsCount,
        action_result: actionResult,
        ...getCateringCommonProps(),
    })
}

export const trackCateringUserBehaviorClearCartFlowClearCart = (shopItemsCount, cartValue) => {
    track({
        name: 'catering_user_behavior_clear_cart_flow_clear_cart',
        shop_items_count: shopItemsCount,
        cart_value: cartValue,
        ...getCateringCommonProps(),
    })
}

export const trackCateringUserBehaviorClearCartFlowCartCleared = (itemsClearedCount, cartValueCleared) => {
    track({
        name: 'catering_user_behavior_clear_cart_flow_cart_cleared',
        items_cleared_count: itemsClearedCount,
        cart_value_cleared: cartValueCleared,
        ...getCateringCommonProps(),
    })
}

export const trackCateringUserBehaviorClearCartFlowCompletedThenCatering = (completedOrderValue, timeToCatering) => {
    track({
        name: 'catering_user_behavior_clear_cart_flow_completed_then_catering',
        completed_order_value: completedOrderValue,
        time_to_catering: timeToCatering,
        ...getCateringCommonProps(),
    })
}

// 3. Conversion rate
export const trackCateringConversionRatePageViewed = () => {
    track({
        name: 'catering_conversion_rate_page_viewed',
        ...getCateringCommonProps(),
    })
}

export const trackCateringConversionRateCheckoutStarted = (itemsCount, cartValue, cartId) => {
    track({
        name: 'catering_conversion_rate_checkout_started',
        items_count: itemsCount,
        cart_value: `$${(cartValue/100).toFixed(2)}`,
        cart_id: cartId,
        ...getCateringCommonProps(),
    })
}

export const trackCateringConversionRateCheckoutCompleted = (orderId, itemsCount, totalValue, paymentMethod) => {
    track({
        name: 'catering_conversion_rate_checkout_completed',
        order_id: orderId,
        items_count: itemsCount,
        total_value: `$${totalValue.toFixed(2)}`,
        payment_method: paymentMethod,
        ...getCateringCommonProps(),
    })
}

// 4. Cart abandonment rate
export const trackCateringCartAbandonmentRateItemAdded = (itemId, itemName, category, price, quantity) => {
    track({
        name: 'catering_cart_abandonment_rate_item_added',
        item_id: itemId,
        item_name: itemName,
        category: category,
        price: `$${price/100}`,
        quantity: quantity,
        ...getCateringCommonProps(),
    })
}

export const trackCateringCartAbandonmentRateCartAbandoned = (itemsCount, cartValue, timeInCart, lastAction) => {
    track({
        name: 'catering_cart_abandonment_rate_cart_abandoned',
        items_count: itemsCount,
        cart_value: `$${cartValue.toFixed(2)}`,
        time_in_cart: timeInCart,
        last_action: lastAction,
        ...getCateringCommonProps(),
    })
}


// 5. Cancelled orders
export const trackCateringCancelledOrdersCancellationInitiated = (orderId, orderStatus) => {
    track({
        name: 'catering_cancelled_orders_cancellation_initiated',
        order_id: orderId,
        order_status: orderStatus,
        ...getCateringCommonProps(),
    })
}

export const trackCateringCancelledOrdersOrderCancelled = (orderId, orderValue, itemsCount, cancellationReason) => {
    track({
        name: 'catering_cancelled_orders_order_cancelled',
        order_id: orderId,
        order_value: `$${orderValue.toFixed(2)}`,
        items_count: itemsCount,
        cancellation_reason: cancellationReason,
        ...getCateringCommonProps(),
    })
}

// 6. Location selection - FTE
export const trackCateringLocationSelectionFteSelectorOpened = (previousOrderType, currentLocation) => {
    track({
        name: 'catering_location_selection_fte_selector_opened',
        previous_order_type: previousOrderType,
        current_location: currentLocation,
        ...getCateringCommonProps(),
    })
}

export const trackCateringLocationSelectionFteDefaultKept = (storeId, storeName, previousOrderType) => {
    track({
        name: 'catering_location_selection_fte_default_kept',
        store_id: storeId,
        store_name: storeName,
        previous_order_type: previousOrderType,
        ...getCateringCommonProps(),
    })
}

export const trackCateringLocationSelectionFteDifferentStoreSelected = (storeId, storeName, previousOrderType, changedFromDefault) => {
    track({
        name: 'catering_location_selection_fte_different_store_selected',
        store_id: storeId,
        store_name: storeName,
        previous_order_type: previousOrderType,
        changed_from_default: changedFromDefault,
        ...getCateringCommonProps(),
    })
}

export const trackCateringLocationSelectionFteSelectorExited = (itemsInCart, timeInSelector, previousOrderType) => {
    track({
        name: 'catering_location_selection_fte_selector_exited',
        items_in_cart: itemsInCart,
        time_in_selector: timeInSelector,
        previous_order_type: previousOrderType,
        ...getCateringCommonProps(),
    })
}

// 7. Order date/time cart adjustment
export const trackCateringOrderDatetimeCartAdjustmentReviewOrderViewed = (currentDate, currentTime, availableSlotsCount) => {
    track({
        name: 'catering_order_datetime_cart_adjustment_review_order_viewed',
        current_date: currentDate,
        current_time: currentTime,
        ...getCateringCommonProps(),
    })
}

export const trackCateringOrderDatetimeCartAdjustmentChangeClicked = (currentDate, currentTime, pageContext) => {
    track({
        name: 'catering_order_datetime_cart_adjustment_change_clicked',
        current_date: currentDate,
        current_time: currentTime,
        page_context: pageContext,
        ...getCateringCommonProps(),
    })
}

export const trackCateringOrderDatetimeCartAdjustmentDatetimeChanged = (oldDate, oldTime, newDate, newTime, reason = null) => {
    track({
        name: 'catering_order_datetime_cart_adjustment_datetime_changed',
        old_date: oldDate,
        old_time: oldTime,
        new_date: newDate,
        new_time: newTime,
        reason: reason,
        ...getCateringCommonProps(),
    })
}

export const trackCateringOrderDatetimeCartAdjustmentChangeCompleted = (newDate, newTime, conversionResult) => {
    track({
        name: 'catering_order_datetime_cart_adjustment_change_completed',
        new_date: newDate,
        new_time: newTime,
        conversion_result: conversionResult,
        ...getCateringCommonProps(),
    })
}

// 8. Sales
export const trackCateringSalesOrderCompleted = (orderId, totalValue, itemsCount, itemDetails, storeId, deliveryType, currency = 'USD') => {
    track({
        name: 'catering_sales_order_completed',
        order_id: orderId,
        total_value: `$${totalValue.toFixed(2)}`,
        items_count: itemsCount,
        item_details: itemDetails,
        store_id: storeId,
        delivery_type: deliveryType,
        currency: currency,
        ...getCateringCommonProps(),
    })
}

export const trackCateringSalesItemSold = (itemId, itemName, category, price, quantity, orderId, userId) => {
    track({
        name: 'catering_sales_item_sold',
        item_id: itemId,
        item_name: itemName,
        category: category,
        price: `$${price.toFixed(2)}`,
        quantity: quantity,
        order_id: orderId,
        user_id: userId,
        ...getCateringCommonProps(),
    })
}

// 9. Basket Size
export const trackCateringBasketSizeCalculated = (itemsCount, basketValue) => {
    track({
        name: 'catering_basket_size_calculated',
        items_count: itemsCount,
        basket_value: basketValue,
        ...getCateringCommonProps(),
    })
}

export const trackCateringBasketSizeCheckoutSummaryViewed = (itemsCount, subtotal, fees, taxes, totalValue, averageItemPrice) => {
    track({
        name: 'catering_basket_size_checkout_summary_viewed',
        items_count: itemsCount,
        subtotal: `$${(subtotal / 100).toFixed(2)}`,
        fees: `$${(fees / 100).toFixed(2)}`,
        taxes: `$${(taxes / 100).toFixed(2)}`,
        total_value: `$${(totalValue / 100).toFixed(2)}`,
        average_item_price: `$${(averageItemPrice / 100).toFixed(2)}`,
        ...getCateringCommonProps(),
    })
}
